































































































































import Vue from 'vue'
import ProductOptionsDropdown from '@/common/components/ProductOptionsDropdown.vue'
import ModalEditPattern from '@/product/components/modal/ModalEditPattern.vue'
import SectionTitle from '@/product/components/SectionTitle.vue'
import { EditPatternOption, ColorPatternOption } from '@/model'
import { Product } from '@/model/product'
import { SkuColorPattern } from '@/model/printableSku'

export default Vue.extend({
  components: {
    ProductOptionsDropdown,
    ModalEditPattern,
    SectionTitle
  },
  props: {
    titleIndex: {
      type: Number,
      default: 2
    }
  },
  data(): {
    showModalEditPattern: boolean,
    singleColorPatternState: boolean
  } {
    return {
      showModalEditPattern: false,
      singleColorPatternState: false
    }
  },
  computed: {
    product(): Product {
      return this.$store.getters.product
    },
    selectedColorPatternOption(): ColorPatternOption {
      return this.$store.getters.selectedColorPatternOption
    },
    selectedEditPattern(): EditPatternOption {
      return this.$store.getters.selectedEditPattern
    },
    singleColorPatternStateTitle(): string {
      return this.singleColorPatternState ? '閉じる' : '詳細表示'
    },
    singleEditPattern(): boolean {
      return this.product.edit_pattern_options.length == 1
    }
  },
  methods: {
    toggleSingleColorPattern() {
      this.singleColorPatternState = !this.singleColorPatternState
    },
    toggleModalEditPattern() {
      this.showModalEditPattern = !this.showModalEditPattern
    },
    onCloseEditPatternModal() {
      this.toggleModalEditPattern()
    },
    onSettlementEditPatternModal(payload: EditPatternOption) {
      this.$store.commit('setSelectedEditPatternId', payload.id)
      this.toggleModalEditPattern()
      this.refreshProductInfo({ disabledLoading: true })
    },
    onChangeColorPattern(content:string, pattern: SkuColorPattern) {
      this.$store.commit('setSelectedId', { content, id: pattern.id })
      this.refreshProductInfo({
        disabledLoading: true
      })
    },
    refreshProductInfo(payload?: { param?: number, queries?: any, loadImageView?: boolean, disabledLoading?: boolean }) {
      this.$emit('refreshProductInfo', payload || {})
    }
  }
})
